import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const SET_EMAIL_SETTINGS = 'SET_EMAIL_SETTINGS';
export const SET_EMAIL_SETTINGS_ERROR = 'SET_EMAIL_SETTINGS_ERROR';
export const SET_EMAIL_SETTINGS_LOADING = 'SET_EMAIL_SETTINGS_LOADING';

export const setEmailSettings = (data) => ({
  type: SET_EMAIL_SETTINGS,
  payload: data,
});

export const setEmailSettingsError = (data) => ({
  type: SET_EMAIL_SETTINGS_ERROR,
  payload: data,
});

export const setEmailSettingsLoading = (isLoading) => ({
  type: SET_EMAIL_SETTINGS_LOADING,
  payload: isLoading,
});

export const getEmailSettings = () => (dispatch) => {
  dispatch(setEmailSettingsLoading(true));
  const url = `${API_BASE_URL}/api/email-settings`;

  return axios
    .get(url)
    .then((response) => {
      dispatch(setEmailSettings(response.data.data));
      dispatch(setEmailSettingsLoading(false));
      return response.data.data;
    })
    .catch((err) => {
      dispatch(setEmailSettingsLoading(false));
      dispatch(setEmailSettingsError({ ...err.response, type: 'modal' }));
      throw err;
    });
};

export const updateEmailSettings = (settings) => (dispatch) => {
  const url = `${API_BASE_URL}/api/email-settings`;

  return axios
    .put(url, settings)
    .then((response) => {
      dispatch(showMessage({ message: 'Email settings updated successfully' }));
      dispatch(setEmailSettings(response.data.data));
      return response.data.data;
    })
    .catch((err) => {
      // The axios interceptor (jwtService) rejects with the response itself;
      // a network failure rejects with the raw error, which carries .response.
      const response = err.response || err;
      const errorMsg = response?.data?.message || 'Error updating email settings';
      dispatch(showMessage({ message: errorMsg, variant: 'error' }));
      dispatch(setEmailSettingsError({ ...response, type: 'modal' }));
      throw err;
    });
};

export const testEmailConnection = () => (dispatch) => {
  const url = `${API_BASE_URL}/api/email-settings/test`;

  return axios
    .post(url)
    .then((response) => {
      dispatch(showMessage({ message: 'SMTP connection successful' }));
      return response.data;
    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || 'SMTP connection failed';
      dispatch(showMessage({ message: errorMsg, variant: 'error' }));
      throw err;
    });
};

export const testEmailCredentials = (credentials) => (dispatch) => {
  const url = `${API_BASE_URL}/api/email-settings/test-credentials`;

  return axios
    .post(url, credentials)
    .then((response) => {
      dispatch(showMessage({ message: 'SMTP connection successful' }));
      return response.data;
    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || 'SMTP connection failed';
      dispatch(showMessage({ message: errorMsg, variant: 'error' }));
      throw err;
    });
};
